app.EmployerReviewMatrix = (
    function () {
        var reviewMatrix = {
            Init: function () {
                //this is an "active grid" that needs to loaded after page load sincethere is a race conditon that happens 
                //When the page loads with persistent grid and the sort isn't applied
                //load the grid when the doc is ready Since this is mobile it needs to be triggered for the IsMobile
                //app.page.components["ReviewMatrix"][0].refreshGrid();

                const interviewFilter = $('#show-interview-only');
                interviewFilter.prop('checked', false); // reset on init

                interviewFilter.change((el) => {
                    if (interviewFilter.is(':checked')) {
                        $('tr').filter('[data-interview="false"]').hide();
                    }
                    else {
                        $('tr').show();
                    }
                });
            }
        };

        return reviewMatrix;
    }()
);